import React from 'react';
import {MdOutlineBook, MdPerson, MdDateRange} from "react-icons/md";
import {Select, MenuItem} from '@mui/material';
import PropTypes from "prop-types";
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import SoftBox from "../../../components/SoftBox";
import oneColumn from "assets/images/one-column.svg";
import multiColumn from "assets/images/multi-column.svg";
import CustomSelect from "../../../reusableComponents/Select/CustomSelect";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

function MetaData({
                      inputContainerStyle,
                      inputStyle,
                      formData,
                      handleInputChange,
                      setIsFocused,
                      errors,
                      handleSelectChange,
                      onMultiColumnChange,
                      languages,
                      handleBlur,
                      isEditable,
                  }) {
    const { t } = useTranslation("publicationsTranslation");
    const { i18n } = useTranslation();

    const handleTitleAndAuthorBlur = () => {
        handleBlur();
        setIsFocused(false)
    }

    const handleCustomSelectChange = (name, value) => {
        const event = { target: { name, value } };
        handleSelectChange(event);
    };


    return (
        <>
            <label htmlFor="title" className="label-style">
                {t("title")} <span style={{ color: errors.title ? 'red' : 'black' }}>*</span>
            </label>
            <div style={{
                ...inputContainerStyle,
                borderColor: errors.title ? 'red' : inputContainerStyle.borderColor
            }}>
                <MdOutlineBook className="icon-style" style={{ color: errors.title ? 'red' : 'inherit' }} />
                <input
                    type="text"
                    id="title"
                    name="title"
                    style={{ ...inputStyle, borderColor: errors.title ? 'red' : inputStyle.borderColor }}
                    value={formData.title}
                    onChange={handleInputChange}
                    onFocus={() => setIsFocused(true)}
                    onBlur={handleTitleAndAuthorBlur}
                    placeholder={t("titlePlaceholder")}
                />
            </div>
            {errors.title && <p className="error-text">{errors.title}</p>}


            <div style={{display: 'flex', gap: '20px'}}>
                <div style={{flex: 1}}>
                    <label htmlFor="author" className="label-style">{t("author")}</label>
                    <div style={inputContainerStyle}>
                        <MdPerson className="icon-style"/>
                        <input
                            type="text"
                            id="author"
                            name="author"
                            style={inputStyle}
                            value={formData.author}
                            onChange={handleInputChange}
                            onFocus={() => setIsFocused(true)}
                            onBlur={handleTitleAndAuthorBlur}
                            placeholder={t("authorPlaceholder")}
                        />
                    </div>
                    {errors.author && <p className="error-text">{errors.author}</p>}
                </div>

                <div style={{flex: 1}}>
                    <label htmlFor="publicationDate" className="label-style">{t("publicationDate")}</label>
                    <div style={inputContainerStyle}>
                        <MdDateRange className="icon-style" />
                        <input
                            type="text"
                            id="publicationDate"
                            name="publicationDate"
                            style={inputStyle}
                            value={formData.publicationDate}
                            onChange={handleInputChange}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            placeholder={t("publicationDatePlaceholder")}
                        />
                    </div>
                    {errors.publicationDate && <p className="error-text">{errors.publicationDate}</p>}
                </div>
            </div>

            <div style={{display: 'flex', gap: '20px'}}>
                <div style={{flex: 1}}>
                    <label htmlFor="targetLanguage" className="label-style">
                     {t("targetLanguage")}<span style={{ color: errors.targetLanguage ? 'red' : 'black' }}>*</span>
                    </label>
                    {isEditable ? (
                        <>
                            <CustomSelect
                                id="targetLanguage"
                                fullWidth={true}
                                value={formData.targetLanguage}
                                onChange={(value) => handleCustomSelectChange("targetLanguage", value)}
                                name="targetLanguage"
                                placeholder={t("selectTargetLanguage")}
                                error={errors.targetLanguage}
                                options={languages
                                    .filter((languageData) => languageData.language !== "Ottoman")
                                    .map((languageData) => ({
                                        value: languageData.language,
                                        label: i18n.language === 'ar' ? languageData.language_ar || languageData.language : languageData.language,
                                    }))}
                                onBlur={handleBlur}
                            />
                    {errors.targetLanguage && <p className="error-text">{errors.targetLanguage}</p>}
                        </>): (
                        <div style={inputContainerStyle}>
                            <input
                                className="label-style"
                                type="text"
                                id="targetLanguage"
                                name="targetLanguage"
                                style={inputStyle}
                                value={formData.targetLanguage}
                                disabled={!isEditable}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

MetaData.propTypes = {

    inputContainerStyle: PropTypes.object,
    inputStyle: PropTypes.object,
    formData: PropTypes.object,
    handleInputChange: PropTypes.func,
    setIsFocused: PropTypes.func,
    errors: PropTypes.object,
    handleSelectChange: PropTypes.func,
    languages: PropTypes.arrayOf(PropTypes.object),
    handleBlur: PropTypes.func,
    onMultiColumnChange: PropTypes.func,
    isEditable: PropTypes.bool,
}
export default MetaData;
